// test1039
(1039 && 0);
